import { z } from "zod";
import { ScopeSchema } from "./primitives.js";

export const RiskLevelSchema = z.enum(["read", "mutate", "destructive"]);
export type RiskLevel = z.infer<typeof RiskLevelSchema>;

export const DataSensitivitySchema = z.enum([
  "none",
  "pii",
  "payment",
  "credentials",
  "config",
  "phi"
]);
export type DataSensitivity = z.infer<typeof DataSensitivitySchema>;

export const OperationRiskSchema = z.object({
  operationId: z.string().min(1),
  level: RiskLevelSchema,
  irreversible: z.boolean(),
  dataSensitivity: z.array(DataSensitivitySchema).default([]),
  crossTenant: z.boolean().default(false),
  rationale: z.string().min(1),
  suggestedScopes: z.array(ScopeSchema).min(1),
  /** OWASP/MITRE tags this operation maps to. */
  owaspMcp: z.array(z.string()).default([]),
  mitreAtlas: z.array(z.string()).default([])
});
export type OperationRisk = z.infer<typeof OperationRiskSchema>;

export const RiskModelSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  operations: z.array(OperationRiskSchema),
  summary: z.object({
    read: z.number().int().nonnegative(),
    mutate: z.number().int().nonnegative(),
    destructive: z.number().int().nonnegative(),
    irreversibleCount: z.number().int().nonnegative()
  })
});
export type RiskModel = z.infer<typeof RiskModelSchema>;
